module.exports = __webpack_public_path__ + "img/img_home_panel_3.b649e21b.jpg";